var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyGridback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 1008,
    viewBox: "0 0 369 1008",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 515H1H0V538L1 549L2 556L3 561L6 571L7 574L12 583L18 590L27 595C27 595.667 27.8486 597 31.243 597H41V596L44 593V592L33 579L29 573L24 562L23 557V551L24 547L25 544H26L27 547L28 551L29 554L30 557L32 562L34 567L37 572H42L43 571L44 568L45 564V527L42 520L41 517L40 515Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M369 526H324L323 530.5L322 538L321 543.5L320 553L323 563C323.333 566 324.6 572 327 572H331L334 568L337 556L338 546.5L338.5 541H340L345 546.5V553L343.5 560.5L333 579L327 587V589.5C327 591.9 328.333 594.833 329 596L338 595.5L352 587.5L360 577L366 563L368 553L369 546.5V526Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134 48.0001C134 35.5 137.5 18 149.5 9.5C159.382 2.5 173.83 -3.33306e-10 184 0V24V48.0001H157.5H134Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233 48C233 35.5 229.5 18 217.5 9.49998C208.311 0.685766 194.17 -3.33306e-10 184 0V48H233Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92 176H184V239H92V176Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102 358H184V419H102V358Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95 479H184V554H88L95 479Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88 554H184L178 621H86L88 554Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88 554H184L178 621H86L88 554Z",
    fill: "#D9D9D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M279 554H184L192 621H282L279 554Z",
    fill: "#D9D9D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M279 554H184L192 621H282L279 554Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86 621H178L171 689H88L86 621Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191 621H282L277 689H198L191 621Z",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88 689H171L165 756H90L88 689Z",
    fill: "#D9D9D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198 689H277L278 756H203L198 689Z",
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90 756H165L163 819H88V788L90 756Z",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203 756H278L280 794V809.5V819H206L203 756Z",
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M206 819H280L267 895H219L206 819Z",
    fill: "#D9D9D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88 819H163L149.824 893H98.1351L88 819Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98 893H149V930.146V963.5V995L143.891 998.841L139.292 1001.38L129.584 1005.46L123.964 1007.49L117.321 1008H111.19L106.591 1007.49L101.993 1005.46L97.3942 1002.4L92.2847 999.35L89.219 994.77L82.5766 986.628L79.5109 981.031L79 974.925L84.6204 970.345L93.8175 959.15L98.4161 944.903L99.9489 929.637L98 893Z",
    fill: "#D9D9D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M291 358H350L359 417H303L291 358Z",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31 293H90L77 358H17L31 293Z",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17 358H77L64 418H9L17 358Z",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267 895H219V931.5V964V995L222 999L226.5 1001.5L236 1005.5L241.5 1007.5L248 1008H254L258.5 1007.5L263 1005.5L267.5 1002.5L272.5 999.5L275.5 995L282 987L285 981.5L285.5 975.5L280 971L271 960L266.5 946L265 931L267 895Z",
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40 239.003C40 231.255 40.5234 211.162 43.4 204.003C46.2766 196.845 45.1048 198.982 50.42 193.503C55.7352 188.025 64.48 182.001 71.5 179.003C79.06 175.776 74.72 176.003 92 176.003V179.503L92 210.503L92 239.003H40Z",
    fill: "#D9D9D9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M327 239C327 230.919 327.731 222.466 325.5 215C323.269 207.534 319.122 199.714 315 194C310.878 188.286 302.886 185.092 297.5 182C292.114 178.908 279.83 176 274 176V239H327Z",
    fill: "#D9D9D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184 479H271L279 554H272.67H229.649H184V479Z",
    fill: "#D9D9D9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134 48H184V85H134V48Z",
    fill: "#D9D9D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M184 48H232.98L234 85H184V48Z",
    fill: "#D9D9D9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M134.016 85H184V176H88L112.74 171.5L136.49 159.5L149.849 140.5L148 114.5L141.5 98.5L134.016 85Z",
    fill: "#D9D9D9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M184 176H274V239H184V176Z",
    fill: "#D9D9D9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40 239.003H90V293.003H31L40 239.003Z",
    fill: "#D9D9D9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90 239H184V358H101.872L90 293V239Z",
    fill: "#D9D9D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184 239H278V295L265.872 358H184V239Z",
    fill: "#D9D9D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M278 239H327L336 295H278V239Z",
    fill: "#D9D9D9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M278 295H336L350 358H291L278 295Z",
    fill: "#D9D9D9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9 418H64L46 480H3L9 418Z",
    fill: "#D9D9D9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184 358H266L263.976 420H184V358Z",
    fill: "#D9D9D9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M101.921 419H184V479H95L101.921 419Z",
    fill: "#D9D9D9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184 420H263.92L271 479H184V420Z",
    fill: "#D9D9D9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M303 417H359L363 480H323L303 417Z",
    fill: "#D9D9D9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M323 480H363L365 493L366.5 505.5L369 526H324L323 480Z",
    fill: "#D9D9D9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97747 480H45.9753L39 515H0L2.97747 480Z",
    fill: "#D9D9D9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M184 85H234L223.815 115.5L222.084 138.5L225.891 149L237.804 160.5L254.174 169L275 176H184L184 85Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyGridback);
export default __webpack_public_path__ + "static/media/body-grid back.46c65b9eca3b889bda4b07a849b4a062.svg";
export { ForwardRef as ReactComponent };